import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-project-mini-wizard-expandable" }
const _hoisted_2 = {
  class: "_flexwrap _jc-sb _ai-c gfu-1of1 _ai-fs _mb-0",
  "data-qa": "mini-wizard-expandable-summary"
}
const _hoisted_3 = {
  class: "gfu-bt--b1",
  "data-qa": "mini-wizard-expandable-summary:Backer"
}
const _hoisted_4 = { class: "gfu-1of1 _flexbtwn _ai-c" }
const _hoisted_5 = { class: "gfu-bt--caption _ttu" }
const _hoisted_6 = {
  class: "gfu-project-mini-wizard__price _tc--white _mr-1",
  "data-qa": "mini-wizard-expandable-summary:AlreadyPledged"
}
const _hoisted_7 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption _tc--white"
}
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = {
  class: "gfu-bt--caption gfu-1of1 _mb-1 _mt-1",
  "data-qa": "mini-wizard-expandable-summary:Text"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "_flexcol" }
const _hoisted_12 = { class: "gfu-bt--caption _ttu" }
const _hoisted_13 = { class: "gfu-project-mini-wizard__price _mr-1" }
const _hoisted_14 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption"
}
const _hoisted_15 = ["href", "disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_go_to_checkout = _resolveComponent("go-to-checkout")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_display_currency_price = _resolveComponent("display-currency-price")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gfu-project-bottom-bar__content gfu-project-mini-wizard-expandable__summary gfu-project-mini-wizard-expandable__summary--compact", [{ 'gfu-project-mini-wizard-expandable__summary--alt-background': !_ctx.hasSameItemsAsParent }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasSameItemsAsParent)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardBackerWithoutNumberText), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardExpandablePledgeValueText), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$format(_ctx.pledge.totalValueConverted, 'C2', _ctx.pledge.currencySymbol)), 1 /* TEXT */),
                  (_ctx.hasTaxHandlingEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("a", {
                  href: "",
                  class: "gfu-btn gfu-btn--soft gfu-btn--narrow gfu-btn--transparent-inverse",
                  onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onUpgradePledgeClick && $options.onUpgradePledgeClick(...args)), ["prevent"])),
                  "data-qa": "mini-wizard-expandable-summary:Upgrade"
                }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardUpgradePledgeShortButton), 1 /* TEXT */),
                (_ctx.currentPledge.manageShippingUrl)
                  ? (_openBlock(), _createBlock(_component_go_to_checkout, {
                      key: 0,
                      "continue-url": _ctx.currentPledge.manageShippingUrl
                    }, {
                      default: _withCtx(({ onInvoke }) => [
                        _createElementVNode("a", {
                          href: _ctx.currentPledge.manageShippingUrl,
                          class: "gfu-btn gfu-btn--soft gfu-btn--narrow gfu-btn--light-transparent",
                          onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                          "data-qa": "mini-wizard-expandable-button:Complete"
                        }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCompletePledgeShortButton), 9 /* TEXT, PROPS */, _hoisted_8)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["continue-url"]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.pledge.parentOrder)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.MiniWizardPledgeModifiedText, _ctx.$format(_ctx.pledge.parentOrder.totalValueConverted, 'C2', _ctx.pledge.parentOrder.currencySymbol))), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_tooltip, {
                    text: _ctx.Resources.Homepage.MiniWizardNoShippingTooltip
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "circle-info" })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["text"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCurrentPledgeLabel), 1 /* TEXT */)
                ]),
                _createVNode(_component_display_currency_price, {
                  "effective-price": _ctx.pledge.totalValueConverted
                }, {
                  "effective-price": _withCtx(({ effectivePrice }) => [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(effectivePrice), 1 /* TEXT */),
                    (_ctx.hasTaxHandlingEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["effective-price"])
              ]),
              (!_ctx.isPledgeEmpty && _ctx.currentPledge.checkoutUrl)
                ? (_openBlock(), _createBlock(_component_go_to_checkout, {
                    key: 0,
                    "continue-url": _ctx.currentPledge.checkoutUrl
                  }, {
                    default: _withCtx(({ onInvoke }) => [
                      _createElementVNode("a", {
                        href: _ctx.currentPledge.checkoutUrl,
                        disabled: _ctx.hasSameItemsAsParent,
                        class: "gfu-project-mini-wizard-expandable__cta gfu-btn gfu-btn--soft gfu-btn--narrow gfu-btn--accent",
                        onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                        "data-qa": "mini-wizard-expandable-button:Pledge"
                      }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardSubmitChangesButton), 9 /* TEXT, PROPS */, _hoisted_15)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["continue-url"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ])
  ], 2 /* CLASS */))
}